// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"815db4b4","471":"5a5644e3","527":"ddffc162","802":"31d6cfe0"}[chunkId] + ".chunk.css";
};